import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { Schemy } from '@stetamalo/cloud-platform/lib/schemy';
import { tz } from 'moment-timezone';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { Sucursal } from '../../entities/sucursal';

export type Interface = ApiInterface<{
  response: Sucursal;
  pathParams: EmptyObject;
  body: Omit<Sucursal, 'tenantId' | 'createdAt' | 'updatedAt' | 'id'>;
  claims: { tenantId: string };
  queryParams: EmptyObject;
}>;

const timezoneList = tz
  .names()
  .sort((a, b) => a.localeCompare(b))
  .map((tzName) => tzName);

export const config: ApiConfig<Interface> = {
  name: 'api-create-sucursal',
  method: 'POST',
  basePath: 'sucursal',
  path: '/',
  tablePermission: 'readWrite',
  metadataAuth: {
    onlySuperAdmin: true,
  },
  scope: 'ADMIN',
  schema: Schemy.schema<Interface['body']>({
    name: { type: String, required: true },
    address: { type: String, required: true },
    country: { type: String, required: true, enum: ['MX', 'US'] },
    phone: { type: String, required: true },
    adminName: { type: String, required: true },
    adminEmail: { type: String, required: true },
    status: { type: String, default: 'ACTIVE', enum: ['ACTIVE', 'INACTIVE'] },
    alias: { type: String, required: true },
    utc: { type: String, required: true, enum: timezoneList },
    workingHours: {
      monday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
      tuesday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
      wednesday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
      thursday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
      friday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
      saturday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
      sunday: {
        status: { type: Boolean, required: true },
        start: { type: String, required: true },
        end: { type: String, required: true },
      },
    },
  }),
};
